import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  countriesSettings: null,
  loading: false,
};

function onLoadCountriesSettingsRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadCountriesSettingsSuccess(state, { payload }) {
  return {
    ...state,
    loading: false,
    countriesSettings: payload,
  };
}

function onLoadCountriesSettingsError(state) {
  return {
    ...state,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_COUNTRIES_SETTINGS_REQUEST]: onLoadCountriesSettingsRequest,
  [actions.LOAD_COUNTRIES_SETTINGS_SUCCESS]: onLoadCountriesSettingsSuccess,
  [actions.LOAD_COUNTRIES_SETTINGS_ERROR]: onLoadCountriesSettingsError,
});
